import React, { useEffect, useState } from 'react';
import Upload from "../../../components/UI/upload/upload";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/UI/customButton/customButton";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import LoadingFix from "../../../components/loading-fix/loading-fix";
import { useVisaInfo, useVisaRegister } from './zustand';
import Loading from '../../../components/Loading';
import { Button } from 'src/components/UI';
import { useMutation } from 'react-query';
import { ApiErrorType, ResponseType } from 'src/types';
import { Post } from 'src/apis/apiWithType';
import { createFormData } from 'src/utils/new';

export const NewUploadStep = ({ activeStep }: { activeStep: boolean }) => {

  const { t } = useTranslation();

  const [crewMembers, setCrewMembers] = useState<{ [key: string]: Array<{ doc_id: string, file: File }> }>();

  const { forward, back } = useVisaRegister()

  const { data, isLoading: loadingVisa } = useVisaInfo(localStorage.getItem("visaId") ?? '')

  const record = data?.details

  const { mutate, isLoading } = useMutation<Array<ResponseType<any>>, ApiErrorType, {}>({
    mutationFn: async () => {

      if (!crewMembers)
        return Promise.reject()


      return await Promise.all(Object.values(crewMembers)
        .map((i, index) => ({ docs: i, crewId: Object.keys(crewMembers)[index] }))
        .reduce<Array<{ crewId: string, file: File, doc_id: string }>>((pv, cv) => {
          pv = [...pv, ...cv.docs.map(i => ({ crewId: cv.crewId, file: i.file, doc_id: i.doc_id }))]
          return pv
        }, [])
        .map(async doc => Post(`agent/crews/${doc.crewId}/v2-upload-files`, createFormData({
          form: 'new_upload_files',
          ['files[0][document_id]']: doc.doc_id,
          ['files[0][file]']: doc.file
        })))

      )

      // return Promise.resolve()

    },
    mutationKey: ['SendFiles'],
    onSuccess: (res) => {

      toast.success(res?.[0]?.msg)
      forward()
    }
  })


  // useEffect(() => {
  //   if (activeStep) {
  //     crewList?.forEach((item) => {
  //       handleDefault(item);
  //     });
  //   } else {
  //     setCrewMembers([])
  //   }
  // }, [crewList, activeStep]);

  const handleForm = ({ crew_id, name, value }: { crew_id: string, name: string, value: File }) => {


    setCrewMembers({
      ...crewMembers, [crew_id]:
        (crewMembers?.[crew_id] ?? [])?.findIndex(i => i.doc_id == name) != -1
          ? crewMembers?.[crew_id].map(i => i.doc_id == name ? ({ doc_id: name, file: value }) : i) ?? []
          : [...(crewMembers?.[crew_id] ?? []), { doc_id: name, file: value }]
    })
    // setCrewMembers((prevMembers) =>
    //   prevMembers.map((member) =>
    //     member.crew_id === crew_id ? { ...member, [name]: value } : member
    //   )
    // );
  };


  const handleSubmit = async () => {

    if (crewMembers && Object.values(crewMembers).findIndex(i => i.length > 0) != -1)
      mutate({})
    else forward()
    // setLoading(true);
    // const formData = new FormData();
    // crewMembers.forEach((detail, index) => {
    //   Object.keys(detail).forEach((key) => {
    //     formData.append(`crews[${index}][${key}]`,typeof detail[key] !== "string" ? detail[key] : "");
    //   });
    // });

    // formData.append("form", "crew_form");
    // try {
    //   const response = await Post(`agent/visas/set-crew/${localStorage.getItem("visaId")}`, formData, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data',
    //     },
    //   });
    //   forward()
    // } catch (error) {
    //   toast.error(error.data.message || error.data.msg);
    // } finally {
    //   setLoading(false);
    // }
  };

  // const handleDefault = async (id) => {
  //   setLoading(true);
  //   try {
  //     const res = await Get(`agent/profile/crews/${id}`);
  //     const newMember = {
  //       crew_id: id,
  //       passport_file: res?.details.data?.passport_file,
  //       picture: res?.details.data?.picture,
  //       reg_file: res?.details.data?.reg_file,
  //       cdc_file: res?.details.data?.cdc_file,
  //       name: res?.details.data?.name,
  //       last_name: res?.details.data?.last_name,
  //     };


  //     setCrewMembers((prevMembers) => [...prevMembers, newMember]);
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const isDataNeeded = !record?.data?.crews?.every(crew => {


    return record?.data.visa.documents.filter(i => i.type == 'CREW').length <=
      record.docs.filter(i => i.item_id.toString() == crew.crew_id && record?.data.visa.documents.filter(i => i.type == 'CREW').findIndex(d => d.id == i.document_id.toString()) != -1).length
      + (crewMembers?.[crew.crew_id]?.length ?? 0)
  })



  return (
    <div className={`my-container ${activeStep ? "h-auto" : "h-0 overflow-hidden "}`}>
      
      {/* {loading && <LoadingFix />} */}
      
      {isLoading && <div className='w-full h-72 bg-white flex gap-4 flex-row justify-center items-center rounded-lg text-gray-500'>
        <span>{t('LoadingDocs')}</span>
        <Loading />
      </div>}

      {!isLoading && !!record?.data?.crews && record?.data?.crews?.map((crewItem, index) => (
        <div key={index} className="relative bg-white rounded-lg flex flex-col gap-4 w-full !mt-5 py-4 px-4 md:px-[13%] mb-8">
          <span className="text-gray-500">
            {t("uploadText")}
          </span>
          <div className="absolute hidden md:block right-5 top-0 h-full text-center [writing-mode:vertical-lr] text-gray-500">
            {t("crew") + " " + (crewItem.crew.name + " " + crewItem.crew.last_name)}
          </div>
          <div className={`grid grid-cols-1 gap-4 lg:grid-cols-${record?.data.visa.documents.filter(i => i.type == 'CREW')?.length ?? 1}`}>
            {record?.data?.visa?.documents?.filter(i => i.type == 'CREW')?.map(item => {



              var defaultValue = undefined

              if (typeof crewMembers?.[crewItem.crew_id]?.find(i => i.doc_id == item.id)?.file == 'object')
                defaultValue = crewMembers?.[crewItem.crew_id]?.find(i => i.doc_id == item.id)?.file

              else if (record.docs.find(i => i.item_id.toString() == crewItem.crew_id && i.document_id.toString() == item.id)?.filepath)
                defaultValue = record.docs.find(i => i.item_id.toString() == crewItem.crew_id && i.document_id.toString() == item.id)?.filepath


              return <Upload
                en={false}
                onClear={(e: any) => { }}

                defaultValue={
                  defaultValue

                }
                id={`${item.id}-${crewItem.crew_id}`}
                title={item.title}
                name={item.id}
                onChange={(e: any) => handleForm({ crew_id: crewItem.crew_id, name: e.name, value: e.value })}

              />
            })}

            {record?.data?.visa?.documents?.filter(i => i.type == 'CREW')?.length==0 && <span className='text-gray-700 text-sm'>{t('NoNeedForSendDoc')}</span>}
          </div>

        </div>
      ))}

      <div className="flex justify-between pt-10 items-center">
        <div onClick={() => back()} className="text-main cursor-pointer">{t("prevStep")}</div>
        <div className="min-w-[330px]">
          <Button loading={isLoading} type='button' onClick={handleSubmit} keyTitle={t("saveAndNext")} disabled={isDataNeeded} />
        </div>
      </div>
    </div>
  );
};

